// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../k8-opt-exec/bin/redo/shopify/extension/webpack.bin.runfiles/rules_javascript++yarn+redo_npm_css-loader_6.7.3-dc3fc578/files/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../k8-opt-exec/bin/redo/shopify/extension/webpack.bin.runfiles/rules_javascript++yarn+redo_npm_css-loader_6.7.3-dc3fc578/files/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._c-0 {\n  display: flex;\n}\n\n._c-1 {\n  flex-direction: row;\n}\n\n._c-2 {\n  flex-direction: column;\n}\n\n._c-3 {\n  flex-direction: row-reverse;\n}\n\n._c-4 {\n  flex-direction: column-reverse;\n}\n\n._c-5 {\n  align-items: center;\n}\n._c-6 {\n  align-items: flex-start;\n}\n._c-7 {\n  align-items: flex-end;\n}\n._c-8 {\n  align-items: stretch;\n}\n._c-9 {\n  align-items: baseline;\n}\n\n._c-a {\n  align-self: center;\n}\n._c-b {\n  align-self: flex-start;\n}\n._c-c {\n  align-self: flex-end;\n}\n._c-d {\n  align-self: stretch;\n}\n._c-e {\n  align-self: baseline;\n}\n\n._c-f {\n  justify-content: center;\n}\n._c-g {\n  justify-content: flex-start;\n}\n._c-h {\n  justify-content: flex-end;\n}\n._c-i {\n  justify-content: space-between;\n}\n._c-j {\n  justify-content: space-around;\n}\n._c-k {\n  justify-content: space-evenly;\n}\n\n._c-l {\n  flex-wrap: wrap;\n}\n\n._c-m {\n  flex-wrap: nowrap;\n}\n\n._c-n {\n  flex-wrap: wrap-reverse;\n}\n", ""]);
// Exports
export var flex = "_c-0";
export var row = "_c-1";
export var column = "_c-2";
export var rowReverse = "_c-3";
export var columnReverse = "_c-4";
export var alignCenter = "_c-5";
export var alignFlexStart = "_c-6";
export var alignFlexEnd = "_c-7";
export var alignStretch = "_c-8";
export var alignBaseline = "_c-9";
export var alignSelfCenter = "_c-a";
export var alignSelfFlexStart = "_c-b";
export var alignSelfFlexEnd = "_c-c";
export var alignSelfStretch = "_c-d";
export var alignSelfBaseline = "_c-e";
export var justifyCenter = "_c-f";
export var justifyFlexStart = "_c-g";
export var justifyFlexEnd = "_c-h";
export var justifySpaceBetween = "_c-i";
export var justifySpaceAround = "_c-j";
export var justifySpaceEvenly = "_c-k";
export var wrapWrap = "_c-l";
export var wrapNowrap = "_c-m";
export var wrapWrapReverse = "_c-n";
export default ___CSS_LOADER_EXPORT___;
